import { getToken } from './auth';

const BASE = '/api/store';

const authHeader = () => ({
  'Authorization': `Bearer ${getToken()}`,
  'Content-Type': 'application/json',
});

export const apiGet = async (key) => {
  const token = getToken();
  const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
  const res = await fetch(`${BASE}/${key}`, { headers });
  if (!res.ok) throw new Error(`GET ${key} failed: ${res.status}`);
  return res.json();
};

export const apiSet = async (key, value) => {
  const res = await fetch(`${BASE}/${key}`, {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(value),
  });
  if (!res.ok) throw new Error(`PUT ${key} failed: ${res.status}`);
};
